import MediaFile from '@/general/models/MediaFile';
import BaseModel from '@/shared/models/BaseModel';
import DimensionMask from '../constants/DimensionMask';
import RimType from '../constants/RimType';
import TireActionTarget from '../constants/TireActionTarget';
import TireKind from '../constants/TireKind';
import TireMakeOption from '../constants/TireMakeOption';
import TireSeason from '../constants/TireSeason';
import Measurement from './Measurement';
import TireMake from './TireMake';
import TireNote from './TireNote';

export interface TireId {__tireId: number}

export type EAN = string;

export interface EANSearchOption {
    EAN: EAN | null;
    modelDescription: string | null;
}

export default class Tire extends BaseModel<TireId> {
  isMounted = false;
  isNew = false;
  season: TireSeason | null = null;
  rimType: RimType | null = null;
  isRunFlat = false;
  isHomologated = false;
  hasNoiseReduction = false;
  isPressureCorrected = false;
  isPressureSensorReset = false;
  ean: EAN | null = null;
  make: TireMake | null = null;
  model: string | null = null;
  dimension: string | null = null;
  dimensionMask: DimensionMask | null = DimensionMask.RADIAL;
  productionWeek: string | null = null;
  media: Array<MediaFile> = [];
  measurement: Measurement | null = null;
  note: TireNote | null = null;

  static withMountedStatus(): Tire {
    const tire = new Tire();
    tire.isMounted = true;
    return tire;
  }

  static replacement(season: TireSeason | null, isMounted: boolean): Tire {
    const tire = new Tire();
    tire.isNew = true;
    tire.season = season;
    tire.isMounted = isMounted;
    return tire;
  }

  clone(): Tire {
    return Object.assign(new Tire(), this);
  }
}

export interface TireEditData {
  tire: Tire,
  make: TireMake | TireMakeOption | null,
  otherMake: TireMake | TireMakeOption | null,
  target: TireActionTarget,
  kind: TireKind | null,
}
